import { getAppState } from './State';
import { postGraphUrlImgRequestApi } from '../services/AppService';
import { ecoGraphUrlPayload } from '../types';

/* 
    App Store -- is a wrapper around state and data access, 
    abstracts away data access logic out of the components. This
    store is for common data access calls that may be used anywhere
    in the app

 */

const environment = process.env.NODE_ENV;

export const getMyCarvanaState = async () => {
  return getAppState();
};

export const postGraphUrlImgRequest = async (
  graphUrlPayload: ecoGraphUrlPayload,
  graphUrl: string
) => {
  const config = { responseType: 'blob' };
  const response = await postGraphUrlImgRequestApi(
    graphUrlPayload,
    graphUrl,
    environment,
    config
  );
  const src = URL.createObjectURL(response);
  return src;
};
